/**
 * 注册element-ui
 *@author caijing
 *@date 2022/2/28 13:10
 */
import { App } from 'vue';
import registerElement from './register-element';

export function globalRegister(app: App): void {
  app.use(registerElement);
}
